import { SearchQuery } from "../../code/search-query/search-query";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../../code/search-query/query-mapper";
import { DataColumn } from "../../controls/Data.default";
import { DynamicSchema } from "../../controls/DynamicForm.default";

export interface WellbeingMaterialCategoriesViewForm {
  readonly name: string;
  readonly description: string;
}

export const wellbeingMaterialCategoriesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 224,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 320,
    sort: true,
  },
  {
    title: "Materials",
    key: "materialsCount",
    width: 110,
    sort: true,
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    format: "DD/MM/YYYY HH:mm",
    sort: true,
  },
];

const wellbeingMaterialCategoriesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
];

export const mapWellbeingMaterialCategoriesViewQuery = (
  values: WellbeingMaterialCategoriesViewForm,
): SearchQuery =>
  buildSearchQuery(values, wellbeingMaterialCategoriesQueryMappings);

export const wellbeingMaterialCategoriesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
      ],
    },
  ],
};
